<template>
  <label class="multiline-select__group">
    <select
      class="multiline-select__item"
      v-bind:disabled="disabled"
      v-bind:class="{ 'multiline-select__item_empty': isEmptyValue }"
      v-model="value"
    >
      <option
        v-bind:disabled="itemOption.isDisabled"
        v-bind:key="index"
        v-bind:value="itemOption.value"
        v-for="(itemOption, index) in itemOptionList"
      >{{ itemOption.title }}</option>
    </select>
    <span class="multiline-select__placeholder">{{ placeholder }}</span>
    <span v-if="hint" class="multiline-select__hint">{{ hint }}</span>
  </label>
</template>
<script>
/**
 * @description Идентификатор события выбора.
 * @type {string}
 */
const NAME_EVENT_CHANGE = 'change';

/**
 * @description Компонент ряда многострочного выбора.
 * @type {Vue}
 */
export default {
  computed: {
    /**
     * @description Пусто.
     * @type {boolean}
     */
    isEmptyValue: (vm) => !!vm.value,
  },
  data() {
    return {
      /**
       * @description Значение.
       * @type {string}
       */
      value: this.initialValue,
    };
  },
  name: 'MultilineSelectItem',
  props: {
    /**
     * @description Компонент деактивирован.
     * @type {number}
     */
    disabled: {
      required: false,
      type: Boolean,
      default: false,
    },
    title: {
      required: false,
      type: String,
      default: '',
    },
    /**
     * @description Изначальное значение.
     * @type {string|number}
     */
    initialValue: { required: true, type: [Number, String] },
    /**
     * @description Список опций.
     * @type {ItemOption[]}
     */
    itemOptionList: { required: true, type: Array },
    /**
     * @description Заполнитель.
     * @type {string}
     */
    placeholder: { required: true, type: String },
    hint: { required: false, type: String, default: '' },
  },
  watch: {
    value() {
      this.$emit(NAME_EVENT_CHANGE, this.value);
    },
    initialValue() {
      this.value = this.initialValue;
    },
  },
};
</script>
<style scoped lang="scss">
.multiline-select {
  &__group {
    position: relative;
  }
  &__item {
    background-color: #FFFFFF;
    background-image: url("@/assets/img/checked/checked-grey.svg");
    background-position: right 17px center;
    border: 1px solid #C2CFE0;
    border-radius: 4px;
    outline: none;
    height: 40px;
    width: 100%;
    padding-inline: 10px 35px;
    appearance: none;
    font-size: 16px;
    color: #192A3E;
    font-weight: 400;
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    &:focus {
      color: #192A3E;
      background-color: #fff;
      border: 2px solid #0489E0;
      outline: 0;
      background-image: url("@/assets/img/checked/checked-grey-top.svg");
    }
    &:disabled {
      background-color: #fff;
      background-image: url("@/assets/img/checked/checked-grey.svg");
    }
    &.multiline-select__item_empty + .multiline-select__placeholder {
      font-weight: 400;
      font-size: 12px;
      line-height: 16px;
      color: #90A0B7;
      left: 0;
      top: -17px;
    }
  }
  &__placeholder {
    position: absolute;
    top: 9px;
    left: 10px;
    font-weight: 400;
    font-size: 16px;
    color: #192A3E;
    opacity: 0.7;
    transition-timing-function: ease-out;
    transition: .3s;
    pointer-events: none;
    &:hover + .multiline-select__hint {
        display: block;
    }
  }
  &__hint {
    display: none;
    position: absolute;
    top: -100px;
    left: 0;
    background-color: white;
    color: rgba(0,0,0,.87);
    padding: 5px;
    border-radius: 5px;
    box-shadow: 0 0 20px rgba(54, 77, 92, 0.18);
    max-width: 250px;
    font-size: 12px;
    z-index: 2;
    border: 1px solid #c2cfe0;
  }
}
</style>
